import React, { useState } from 'react';
import { homePageReview } from '../../../../services/testimonial';

const useTestimonial = () => {
  const [loading, setLoading] = useState(false);
  const [testimonialData, setTestimonialData] = useState([]);

  const getTestimonial = async () =>{
    setLoading(true);
    try {
      let response = await homePageReview();
      if (response) {
        setTestimonialData(response);
        setLoading(false);
      } else {
        setLoading(false);
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  return {
    loading,
    testimonialData,
    getTestimonial
  };
};

export default useTestimonial;
